import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import _ from 'lodash';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import FormHelperText from '@mui/material/FormHelperText';

import GoogleLogin from '../../components/login/GoogleLogin';
import { boxgreyLine, textsmGrey } from './loginStyle';
import theme from '../../theme';

const SystemLogin = (props) => {
  const {
    userAuth,
    authStatusMsg,
    setUserName,
    setPassword,
    handleLogin,
    handleGoogleLogin
  } = props;

  return (
    <>
      <FormHelperText
        error
        style={{
          textAlign: 'center',
          height: '32px',
          fontSize: 14,
          color: theme.palette.primary.main
        }}
      >
        {authStatusMsg || ''}
      </FormHelperText>

      <Box
        sx={{
          width: '280px',
          margin: '16px auto 0',
          textAlign: 'center'
        }}
      >
        <Box mb={3}>
          <TextField
            fullWidth
            label="帳號"
            placeholder='帳號'
            onChange={(e) => setUserName(e.target.value)}
          />
        </Box>

        <Box mb={3}>
          <TextField
            fullWidth
            label="密碼"
            placeholder='密碼'
            type='password'
            onChange={(e) => setPassword(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                handleLogin();
              }
            }}
          />
        </Box>

        <Button
          fullWidth
          variant='fill-main'
          type='submit'
          onClick={handleLogin}
        >
          登入
        </Button>

        {/* <Stack variant="center-center" mt={3} mb={3}>
          <Box style={boxgreyLine}></Box>
          <Typography style={textsmGrey}>OR</Typography>
          <Box style={boxgreyLine}></Box>
        </Stack>

        <GoogleLogin handleGoogleLogin={handleGoogleLogin} /> */}

      </Box>
    </>
  )
}

export default SystemLogin;